import React from 'react';
import { MessageSquare, Heart, MessageCircle } from 'lucide-react';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import { getCommunityData } from '../../../../utils/aiBriefingsData';
interface CommunityWidgetProps {
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const CommunityWidget: React.FC<CommunityWidgetProps> = ({
  onHide,
  onAsk
}) => {
  const data = getCommunityData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Riassumi i 3 topic principali'
  }, {
    id: '2',
    text: 'Sentiment generale?'
  }];
  return <BentoWidgetCard id="community" title="Community & Gruppi" size="M" lastUpdated="4 min fa" questions={questions} onHide={onHide} onAsk={onAsk} data-id="element-1306">
      <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-1307">
        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1308">
          <MessageSquare className="h-4 w-4 text-blue-600 mb-1" data-id="element-1309" />
          <p className="text-xs text-blue-700" data-id="element-1310">Post</p>
          <p className="text-lg font-bold text-blue-900" data-id="element-1311">
            {data.posts.toLocaleString()}
          </p>
        </div>
        <div className="bg-green-50 rounded-lg p-3" data-id="element-1312">
          <MessageCircle className="h-4 w-4 text-green-600 mb-1" data-id="element-1313" />
          <p className="text-xs text-green-700" data-id="element-1314">Commenti</p>
          <p className="text-lg font-bold text-green-900" data-id="element-1315">
            {data.comments.toLocaleString()}
          </p>
        </div>
        <div className="bg-purple-50 rounded-lg p-3" data-id="element-1316">
          <Heart className="h-4 w-4 text-purple-600 mb-1" data-id="element-1317" />
          <p className="text-xs text-purple-700" data-id="element-1318">Reazioni</p>
          <p className="text-lg font-bold text-purple-900" data-id="element-1319">
            {data.reactions.toLocaleString()}
          </p>
        </div>
      </div>

      <div data-id="element-1320">
        <p className="text-xs font-semibold text-gray-900 mb-2" data-id="element-1321">Temi Caldi</p>
        <div className="flex flex-wrap gap-2" data-id="element-1322">
          {data.hotTopics.map((topic, index) => <div key={index} className="bg-gray-100 rounded-full px-3 py-1" data-id="element-1323">
              <span className="text-xs font-medium text-gray-900" data-id="element-1324">
                #{topic.tag}
              </span>
              <span className="text-xs text-gray-600 ml-1" data-id="element-1325">
                ({topic.count})
              </span>
            </div>)}
        </div>
      </div>
    </BentoWidgetCard>;
};
export default CommunityWidget;